import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import styles from './style.css'
import * as actTableManagement from 'actions/tableManagement'
import FilteredReport from './FilteredReport'
import {formValueSelector} from 'redux-form'

class List extends React.Component {
  render () {
    let {reportDetail, reports, summary} = this.props
    return (reports && reports.length > 0 && <div className={styles.wrapper}>
      <div className={`${styles['summary-data-box']} visible-md visible-lg`}>
        <div className='row'>
          <div className='col-xs-6'>
            <div className={styles['amount']}>{summary.completed}</div>
            <div className={styles['title-center']}>Completed Orders</div>
          </div>
          <div className='col-xs-6'>
            <div className={styles['amount']}>{summary.cancelled}</div>
            <div className={styles['title-center']}>Cancelled Orders</div>
          </div>
        </div>
      </div>

      <table className={styles['table-header']}>
        <thead>
          <tr>
            <th className={styles.name}>Date</th>
            <th className={styles.name}>Receipt Number</th>
            <th className={styles.name}>Served By</th>
            <th className={styles.name}>Pax</th>
            <th className={styles.name}>Duration</th>
            <th className={styles.name}>Status</th>
          </tr>
        </thead>
      </table>
      <div className={styles['table-content-wrapper']}>
        <InfiniteScroll
          pageStart={1}
          loadMore={this._onReachBottom}
          hasMore={this._hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}>
          <table className={styles['table-content']}>
            <tbody>
              {reports.map((report) => {
                return (
                  <FilteredReport
                    report={report}
                    reportDetail={reportDetail}
                    onClickRow={this._onClickRow}
                  />
                )
              })}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>)
  }

  _onClickRow = (report) => {
    const {dispatch} = this.props
    dispatch(actTableManagement.onReportsClickRow(report))
  }

  _onReachBottom = () => {
    let {dispatch, currentPage, reports} = this.props
    let {startDate, endDate} = this.props.search.date
    let {statusIds} = this.props.search

    dispatch(actTableManagement.reportsRequest({
      page: currentPage + 1,
      statusIds,
      startDate,
      endDate,
      previousReports: reports
    }))
  }

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  const {currentPage, totalPage, reportDetail, reports, summary} = state.tableManagement.report
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    search: {
      outletIds: selector(state, 'outletIds'),
      date: selector(state, 'date'),
      statusIds: selector(state, 'statusIds')
    },
    reports,
    currentPage,
    totalPage,
    reportDetail,
    showLoadingSpinnerPage,
    summary
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  reports: React.PropTypes.array,
  reportDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementReport/List/List.js